// ***** use for set token in headers request to api ******
//                     ************
import axios from 'axios';
import OpenNotificationWithIcon from 'layouts/notificationWithIcon/OpenNotificationWithIcon ';
const baseURL = process.env.REACT_APP_Api_Address;
// const baseURL = "http://192.168.8.123:8000/api/v1/";
// const Bearertoken = localStorage.getItem("token");
// const isLoggedIn = Bearertoken ? true : false;

// add auth header with jwt if account is logged in and request is to the api url
// const isApiUrl = request.url.startsWith(baseURL);

const Axios = axios.create({
    baseURL,
    // timeout: 15000,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        // ...(isLoggedIn && {
        //     Authorization: `Bearer ${Bearertoken}`
        // })
    }
});

Axios.interceptors.request.use(async (config) => {
    const token = await localStorage.getItem('token');
    const isLoggedIn = token ? true : false;
    config.headers = {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        // add auth header with jwt if account is logged in and request is to the api url
        ...(isLoggedIn && {
            Authorization: `Bearer ${token}`
        })
    }
    return config
}, error => Promise.reject(error))

Axios.interceptors.response.use(undefined, (response) => {

    // if token expired
    // if (response.response.status === 401) {
    //     alert("توکن شما منقضی شده، نیاز است تا مجددا وارد شوید!")
    //     localStorage.clear();
    //     window.location.href = '/login';
    // }
    if (response.response.status === 401) {
        localStorage.clear();
        OpenNotificationWithIcon("نیاز به ورود مجدد", "توکن شما منقضی شده، دوباره وارد شوید!", "error")
        setTimeout(() => {
            window.location.href = '/login';
        }, 2000);
    }

    //  if some required fields not filled or Unexpected error
    if (response.response.status === 422) {
        try {
            // start map on object
            const objectMap = (obj, fn) =>
                Object.fromEntries(Object.entries(obj).map(([k, v], i) => [k, fn(v, k, i)]))
            // end of map on object
            objectMap(response.response.data.message, v =>
                OpenNotificationWithIcon("خطا", v[0], "error")
            )
        } catch {
            alert("درخواست با خطا مواجه شد")
        }
    }
    return Promise.reject(response);
})


export default Axios;